import {
  AutomatedReviewLog,
  AutomatedReviewLogStatus,
} from 'models/automation/Reviews';
import { Row } from '@tanstack/react-table';
import { useTranslation } from 'react-i18next';
import Tooltip from 'components/tooltip/Tooltip';

import {
  ClockFillIconStyled,
  ExclamationCircleFillIconStyled,
  CheckFillCircleIconStyled,
  XCircleFillIconStyled,
} from './StatusCell.styles';

const STATUS_ICON_MAP = {
  [AutomatedReviewLogStatus.SCHEDULED]: (
    <ClockFillIconStyled data-testid="status-icon-scheduled" />
  ),
  [AutomatedReviewLogStatus.POSTED]: (
    <CheckFillCircleIconStyled data-testid="status-icon-posted" />
  ),
  [AutomatedReviewLogStatus.ALREADY_POSTED]: (
    <CheckFillCircleIconStyled data-testid="status-icon-already-posted" />
  ),
  [AutomatedReviewLogStatus.POSTED_MANUALLY]: (
    <CheckFillCircleIconStyled data-testid="status-icon-posted-manually" />
  ),
  [AutomatedReviewLogStatus.NOT_ELIGIBLE]: (
    <XCircleFillIconStyled data-testid="status-icon-not-eligible" />
  ),
  [AutomatedReviewLogStatus.CANCELLED]: (
    <XCircleFillIconStyled data-testid="status-icon-cancelled" />
  ),
  [AutomatedReviewLogStatus.FAILED]: (
    <ExclamationCircleFillIconStyled data-testid="status-icon-failed" />
  ),
};

const StatusCell = ({ row }: { row: Row<AutomatedReviewLog> }) => {
  const { t } = useTranslation();
  const { status } = row.original;

  return (
    <Tooltip
      id={`status-${status}-tooltip`}
      text={t('pageAutomations.reviews.automatedReviewLogs.statuses.status', {
        context: status,
      })}
    >
      {STATUS_ICON_MAP[status]}
    </Tooltip>
  );
};

export default StatusCell;
